import { Select } from "@mui/material";
import styled from "styled-components";

interface SelectProps {
  width?: string;
}

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  width: 60%;
  height: auto;
  border: 1px solid rgba(213, 213, 213, 0.6);
  background: #fff;
  padding: 12px;
  margin-top: 20px;
  margin: 16px 16px 0px 16px;
`;

export const Column: any = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  flex: ${(props: any) => props?.flex};
`;

export const StrongText: any = styled.p`
  color: #2d5bff;
  font-family: Inter;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 175% */
`;

export const TableTextHeader: any = styled.p`
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: 11.44px;
  text-align: left;
`;

export const TableTextBody: any = styled.p`
  font-family: Inter;
  font-size: 10px;
  font-weight: 500;
  line-height: 11.44px;
  text-align: left;
  color: #ffffff;
`;

export const LightText: any = styled.p`
  color: #333333;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px; /* 233.333% */
`;

export const StyledSelect = styled(Select)<SelectProps>`
  & .MuiOutlinedInput-notchedOutline {
    border: 2px solid #ececec;
    border-radius: 8px;
  }
  width: ${(props) => props.width || "100%"};
`;
